import { render, staticRenderFns } from "./NoSightingsItems.vue?vue&type=template&id=1d06269f"
import script from "./NoSightingsItems.vue?vue&type=script&lang=js"
export * from "./NoSightingsItems.vue?vue&type=script&lang=js"
import style0 from "./NoSightingsItems.vue?vue&type=style&index=0&id=1d06269f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports